export enum ChartGaugeType {
  MODERN = 'Modern',
  CLASSIC = 'Classic'
}
